import axios from '@/api/axios'

const getListBill = (data) => {
    return axios
        .post('/admin/bill/list-bill', {bill: data})
        .then(response => response.data)
}

const getListBonus = (data) => {
    return axios
        .post('/admin/bill/list-bonus', {bill: data})
        .then(response => response.data)
}

const getListBillNew = (data) => {
    return axios
        .post('/admin/bill/list-bill-new', {bill: data})
        .then(response => response.data)
}

const getDepositHistory = (data) => {
    return axios
        .post('/admin/bill/deposit-history', {bill: data})
        .then(response => response.data)
}

export default {
    getListBill,
    getListBonus,
    getListBillNew,
    getDepositHistory
}